import axios from 'axios'
import { generateTrackingId } from '../utils/general.utils'

axios.interceptors.request.use((request) => {
  request.headers['trackingId'] = generateTrackingId()
  return request
})

export default axios
